// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"73eff743","239":"f59496a0","732":"d6a55aa1"}[chunkId] + ".chunk.js";
};